import { useState } from "react";

export default function useExerciseFormValidation() {
  const [errors, setErrors] = useState({});

  /**
   * Valida os dados do exercício e as palavras.
   * @param {Object} current Objeto com os dados do exercício.
   * @param {Object} wordsState Objeto com as strings de palavras aceitas/rejeitadas.
   * @returns {boolean} Retorna true se estiver tudo válido.
   */
  const validate = (current, wordsState) => {
    const newErrors = {};
    if (!current.title || !current.title.pt || current.title.pt.trim() === "") {
      newErrors.titlePt = true;
    }
    if (!current.title || !current.title.en || current.title.en.trim() === "") {
      newErrors.titleEn = true;
    }
    if (
      !current.description ||
      !current.description.pt ||
      current.description.pt.trim() === ""
    ) {
      newErrors.descPt = true;
    }
    if (
      !current.description ||
      !current.description.en ||
      current.description.en.trim() === ""
    ) {
      newErrors.descEn = true;
    }
    if (!wordsState.accepted || wordsState.accepted.trim() === "") {
      newErrors.accepted = true;
    }
    if (!wordsState.rejected || wordsState.rejected.trim() === "") {
      newErrors.rejected = true;
    }
    setErrors(newErrors);
    const keys = Object.keys(newErrors);
    if (keys.length === 0) {
      return true;
    } else {
      return false;
    }
  };

  const clearError = (field) => {
    if (errors[field]) {
      const updatedErrors = { ...errors };
      delete updatedErrors[field];
      setErrors(updatedErrors);
    }
  };

  return {
    errors,
    validate,
    clearError,
    setErrors,
  };
}
